/* ========== FUNNEL CHART ==========
 * Excel renders all funnel slices in a single accent color (accent1 by
 * default) — not the rainbow palette we were using. Each slice still gets
 * the same fill, with the value providing the visual width difference.
 * Per-point colors are honored when authored.
 * =================================== */

import { COLORS } from './utils';

// Excel's default funnel fill — accent1 in the modern Office theme.
var FUNNEL_DEFAULT = '#4472C4';

export function drawFunnelChart(ctx, x, y, width, height, chartObj) {
  var series = chartObj && chartObj.series && chartObj.series[0] ? chartObj.series[0] : null;
  if (!series || series.data.length === 0) return;
  var data = series.data;
  var cats = chartObj.categories || [];
  var pointColors = series.pointColors || [];
  var baseColor = series.color || FUNNEL_DEFAULT;
  var n = data.length;
  var maxVal = Math.max.apply(null, data.map(function (v) { return Math.abs(v); }).concat([1]));
  var sliceH = height / n;

  // Reserve a left band for category labels (like Excel's funnel axis).
  ctx.font = '9px Calibri, Arial';
  var labelBand = 0;
  cats.forEach(function (c) {
    var w = ctx.measureText(c || '').width;
    if (w > labelBand) labelBand = w;
  });
  labelBand = Math.min(labelBand + 8, width * 0.3);
  var plotX = x + labelBand;
  var plotW = width - labelBand;

  data.forEach(function (val, i) {
    var ratio = Math.abs(val) / maxVal;
    var sliceWidth = ratio * plotW;
    var sliceX = plotX + (plotW - sliceWidth) / 2;
    var sliceY = y + i * sliceH;

    // Color: per-point override → series color → default funnel accent.
    // Fall back to palette only when nothing else is set, for back-compat.
    ctx.fillStyle = pointColors[i] || baseColor || COLORS[i % COLORS.length];
    ctx.fillRect(sliceX, sliceY + 1, sliceWidth, sliceH - 2);

    // Category label on the left band (Excel style)
    if (cats[i]) {
      ctx.fillStyle = '#666';
      ctx.font = '9px Calibri, Arial';
      ctx.textAlign = 'right';
      ctx.textBaseline = 'middle';
      ctx.fillText(cats[i], plotX - 4, sliceY + sliceH / 2);
    }

    // Value inside the slice — value only, like Excel (no "label:" prefix)
    var valueStr = val.toLocaleString();
    ctx.font = 'bold 10px Arial';
    if (sliceWidth > ctx.measureText(valueStr).width + 10) {
      ctx.fillStyle = '#fff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(valueStr, plotX + plotW / 2, sliceY + sliceH / 2);
    }
  });
}
